module.exports = __webpack_public_path__ + "img/purchase-icon-active.6dde3313.svg";